import React, { createContext, useContext } from 'react';
import useTranslations from '../hooks/useTranslations';

const TranslationsContext = createContext({});

export const TranslationsProvider = ({ children, configuration, keys = [] }) => {
  const { translations, loading } = useTranslations(keys, configuration);
  return (
    <TranslationsContext.Provider value={{ translations, loading }}>
      {children}
    </TranslationsContext.Provider>
  );
};

export const useTranslationContext = () => useContext(TranslationsContext);
